import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareTimelineRoute: InvariantJiraRoute = {
	name: 'software-timeline',
	path: '/jira/software/projects/:projectKey/boards/:boardId/timeline/:viewId?',
};
